import styled from 'styled-components';
import {caretDown, accountPlaceholder} from '../../../../../assets/symbols/symbols/Symbols.css';
import {BGImageCenter} from '../../../../../globalVariables/GlobalVariables';
import {dFlexCenter} from '../../../../../globalVariables/GlobalFlex';
import {getColor} from '../../../utils/themeUtils';

export const nameCaret = styled.div`
    flex-shrink: 0;
    width: var(--dimension-8);
    height: var(--dimension-8);
    ${dFlexCenter}
    border-radius: var(--radius-full);
    cursor: pointer;
    background: var(--color-bg-surface-default, rgba(0, 0, 0, 0.05));
    &::before {
        content: '';
        width: var(--dimension-3);
        height: var(--dimension-3);
        background-color: ${p => getColor(p.theme.isDarkMode)};
        -webkit-mask: url("${caretDown}") center / contain no-repeat;
        mask: url("${caretDown}") center / contain no-repeat;
    }
`;

export const empty = styled.div`
    padding: var(--space-xl);
    text-align: center;
    font-size: var(--font-size-body-small);
    color: var(--color-text-subtle);
`;

export const avatarPlaceholder = styled.div`
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: var(--radius-full);
    background-color: var(--color-bg-surface-default, rgba(0, 0, 0, 0.05));
    ${BGImageCenter(accountPlaceholder, '24px 24px')};
`;
